import { render, staticRenderFns } from "./HeaderUserArea.vue?vue&type=template&id=035a032a"
import script from "./HeaderUserArea.vue?vue&type=script&lang=js"
export * from "./HeaderUserArea.vue?vue&type=script&lang=js"
import style0 from "./HeaderUserArea.vue?vue&type=style&index=0&id=035a032a&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('035a032a')) {
      api.createRecord('035a032a', component.options)
    } else {
      api.reload('035a032a', component.options)
    }
    module.hot.accept("./HeaderUserArea.vue?vue&type=template&id=035a032a", function () {
      api.rerender('035a032a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/Header/HeaderUserArea.vue"
export default component.exports